import ProductsScreen from "@/UI/screens/ProductsScreen";

export default function ProductsRoute() {
    return <ProductsScreen />;
}
